<template>
    <div class="event-stripe">
        <div :class="['event-stripe__status', `event-stripe__status--${status.state}`]">
            <div class="event-stripe__badge">{{ badge }}</div>
            <div class="event-stripe__text">
                <h3>{{ langJson(title) }}</h3>
                <p>{{ langJson(body) }}</p>
                <p v-if="status.state === 'enabled'" class="event-stripe__payouts">
                    {{ status.payoutsEnabled ? langJson('Payouts are enabled.') : langJson('Payouts will start once Stripe finishes verifying your bank details.') }}
                </p>
            </div>
        </div>
        <div class="event-stripe__actions">
            <BTN v-if="status.state !== 'enabled'" type="active" bh="48" :load="redirecting" @handle="startOnboarding">
                {{ langJson(status.state === 'not_started' ? 'Connect with Stripe' : 'Continue Stripe setup') }}
            </BTN>
            <BTN v-else type="detail" bh="48" @handle="openDashboard">{{ langJson('Open Stripe dashboard') }}</BTN>
        </div>
        <p class="event-stripe__note">{{ langJson('Your Stripe account is shared by all your events. It must be connected before you can launch, but you can submit for review while Stripe verifies you.') }}</p>
        <p class="event-stripe__note">{{ langJson('Ticket sales are charged on your Stripe account: you are the seller buyers see on their statement, Stripe processing fees come out of your balance, and you handle refunds and disputes in your Stripe dashboard. The NFTWerks platform fee is deducted from each sale.') }}</p>
    </div>
</template>
<script>
import organizerApi from '@/api/organizer'
import { apiErrorMessage } from '@/assets/js/organizerEvent'

const COPY = {
    not_started: { badge: '!', title: 'Not connected', body: 'Tickets are sold through your own Stripe account, and revenue is paid out from it. Setting it up takes about 5 minutes.' },
    pending: { badge: '…', title: 'Setup in progress', body: 'Stripe still needs a few details before you can take payments.' },
    enabled: { badge: '✓', title: 'Connected', body: 'Your Stripe account can accept ticket payments.' },
}

export default {
    props: {
        event: { type: Object, required: true },
    },
    data() {
        return { redirecting: false }
    },
    computed: {
        status() {
            return this.event.stripe || { state: 'not_started' }
        },
        badge() {
            return COPY[this.status.state].badge
        },
        title() {
            return COPY[this.status.state].title
        },
        body() {
            return COPY[this.status.state].body
        },
    },
    methods: {
        openDashboard() {
            window.open('https://dashboard.stripe.com', '_blank', 'noopener')
        },
        async startOnboarding() {
            this.redirecting = true
            try {
                const res = await organizerApi.startStripeOnboarding(this.event.id)
                window.location.href = res.data.onboardingUrl
            } catch (err) {
                this.redirecting = false
                this.pushMsg('error', apiErrorMessage(err, this.langJson('Could not open Stripe — please try again')))
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.event-stripe {
    background: var(--color_white);
    border-radius: 32px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    box-sizing: border-box;

    &__status {
        display: flex;
        gap: 16px;
        align-items: flex-start;
    }
    &__badge {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 800;
        font-size: 20px;
        background: #fff6e5;
        color: #b54708;
    }
    &__status--enabled &__badge {
        background: #e7f8ee;
        color: #12a150;
    }
    &__status--not_started &__badge {
        background: #f1e9ff;
        color: #8b5cf6;
    }
    &__text {
        display: flex;
        flex-direction: column;
        gap: 4px;

        h3 {
            font-family: 'Inter';
            font-weight: 700;
            font-size: 18px;
            color: var(--font_deep_color);
        }
        p {
            font-family: 'Lato';
            font-size: 14px;
            color: var(--font_color);
        }
    }
    &__actions {
        display: flex;
    }
    &__payouts {
        color: var(--font_modif_color) !important;
    }
    &__note {
        font-family: 'Lato';
        font-size: 13px;
        color: var(--font_modif_color);
    }
}

@media only screen and (max-width: 1080px) {
    .event-stripe {
        padding: 20px 16px;
        border-radius: 24px;
    }
}
</style>
